<form class="login-form">
  <h2 class="text-center">Login</h2>

  <h5 class="text-center mt-5">Login to access your account</h5>

  <div class="mb-3">
    <mat-form-field>
      <input [formControl]="data.email" type="email" matInput placeholder="Email">
    </mat-form-field>
  </div>

  <div class="mb-3">
    <mat-form-field>
      <input [formControl]="data.password" type="password" matInput placeholder="Password">
    </mat-form-field>
  </div>

  <div class="mb-3 remember-me">
    <mat-checkbox color="primary" [checked]="data.remember" (change)="rememberMe($event)">
      <span textSize="12" textColor="brownish-grey">Remember me</span>
    </mat-checkbox>
  </div>

  <div class="mb-3 text-center mt-3">
    <button type="button" [disabled]="validateFields() || isSubmitting" (click)="login()" class="login__form--button" mat-raised-button
      color="primary">
      Log in
    </button>
  </div>

  <div *ngIf="loginErrorMessage" class="mb-3 text-center">
    <span class="text-danger">{{ loginErrorMessage }}</span>
  </div>

  <div class="mb-3 tmt-3">
    <a [routerLink]="['/forgot-password']" textSize="13" class="text__decoration--none link-color">
      Forgot Password
    </a>
  </div>


  <div class="mb-3 mt-3 register-here">
    <p textSize="13">Don’t have an Account?
      <span textSize="14" class="block--click" (click)="goRegister()">Register Here</span>
    </p>
  </div>

</form>
